<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="420px"
    :modal="false"
    :close-on-click-modal="false"
    custom-class="contact-dialog"
  >
    <div class="contact-dialog-body">
      <div class="contact-icon-wrap">
        <svg width="44" height="44" viewBox="0 0 56 56" fill="none">
          <circle cx="28" cy="18" r="12" stroke="#E87D36" stroke-width="2.5"/>
          <path d="M16 34c0 5 5 10 12 10s12-5 12-10" stroke="#E87D36" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="28" cy="14" r="4" fill="#E87D36"/>
        </svg>
      </div>
      <h3 class="contact-title">联系客户经理</h3>
      <p class="contact-subtitle">如需开通服务，请联系您的专属客户经理</p>
      <div class="contact-info-list">
        <div class="contact-info-item">
          <span class="contact-label">姓名</span>
          <span class="contact-value">{{ info.name }}</span>
        </div>
        <div class="contact-info-item">
          <span class="contact-label">手机号</span>
          <span class="contact-value">{{ info.phone }}</span>
          <span class="copy-btn" title="复制" @click.stop="copyText(info.phone)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          </span>
        </div>
        <div class="contact-info-item">
          <span class="contact-label">微信号</span>
          <span class="contact-value">{{ info.wechat }}</span>
          <span class="copy-btn" title="复制" @click.stop="copyText(info.wechat)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          </span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContactDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      info: {
        name: '樊红',
        phone: '15610242645',
        wechat: 'hong934266120'
      }
    }
  },
  methods: {
    copyText(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({ message: '已复制', type: 'success', duration: 1500 })
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  }
}
</script>

<style>
.contact-dialog {
  border-radius: 8px !important;
  overflow: hidden;
}
.contact-dialog .el-dialog__header {
  padding: 0;
}
.contact-dialog .el-dialog__headerbtn {
  top: 16px;
  right: 16px;
  font-size: 18px;
}
.contact-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #999;
  font-weight: normal;
}
.contact-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #333;
}
.contact-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.contact-dialog-body {
  text-align: center;
  padding: 40px 40px 40px;
}

.contact-icon-wrap {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background: #FFF5ED;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-title {
  font-size: 22px;
  font-weight: bold;
  color: #1D213B;
  margin-bottom: 10px;
}

.contact-subtitle {
  font-size: 14px;
  color: #999;
  margin-bottom: 32px;
}

.contact-info-list {
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #EEE;
}

.contact-info-item {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 52px;
  text-align: left;
}

.contact-info-item + .contact-info-item {
  border-top: 1px solid #EEE;
}

.contact-label {
  font-size: 14px;
  font-weight: bold;
  color: #1D213B;
  width: 72px;
  text-align: left;
  flex-shrink: 0;
}

.contact-value {
  font-size: 15px;
  color: #333;
  margin-left: 16px;
  flex: 1;
}

.copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-left: 4px;
  border-radius: 4px;
  color: #bbb;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s;
}
.copy-btn:hover {
  color: #E87D36;
  background: #FFF5ED;
}
.copy-btn:active {
  color: #d06a20;
}

@media screen and (max-width: 767px) {
  .contact-dialog-body {
    padding: 36px 24px 32px;
  }
}
</style>
